import StyledButton, { ButtonStyle } from "frontend/ui-components/styled-button";
import { CSSProperties, useCallback, useRef } from "react";
import CanvasContentCard from "frontend/ui-components/canvas-content-card/canvas-content-card";

export default function InviteToBoardButton({
  title = "Share",
  style,
  customStyle,
  onInviteClick,
}: {
  title?: string;
  style?: ButtonStyle;
  customStyle?: CSSProperties;
  onInviteClick?: (title?: string) => void;
}) {
  const ref = useRef(null);

  const inviteClickHandler = useCallback(() => {
    onInviteClick && onInviteClick(title);
  }, [onInviteClick, title]);

  return (
    <>
      <StyledButton
        id="invite-to-board-button"
        title={title}
        onClick={inviteClickHandler}
        style={style}
        customStyle={customStyle}
        ref={ref}
      />
      <CanvasContentCard attachToRef={ref} onClick={inviteClickHandler} />
    </>
  );
}
